import { togglePickUpAddressInputs } from "./togglePickUpAddressInputs";

export const adminRideRequestMutate = {
    togglePickUpAddressInputs
};
